export default __webpack_public_path__ + "static/media/DefaultPlayerAvatar.5e956aef.jpg";